//@flow

// Vendors
import React from 'react';
import classnames from 'classnames';

// Components
import { InputGroup, InputCode } from '../../..';
import { InputGroupBackCode } from './InputGroupBackComponents';

// Styles
import './Input-group-back.scss';

// Types
type Props = {
  className?: string,
  autoFocus: boolean,
  channelCode: string,
  resendCodeActionCreator?: Function,
  onResendCodeSuccess?: Function,
  formikProps: FormikProps,
};

/**
 * @visibleName Code
 */
const InputGroupCode = ({
  className,
  autoFocus = false,
  resendCodeActionCreator,
  onResendCodeSuccess,
  formikProps,
  channelCode,
  ...props
}: Props) => (
  
  <InputGroup {...props} className={classnames('input-group-code input-go-back', className)}>
    <InputGroupBackCode
     >
    
    </InputGroupBackCode>
    
    
    {/* <InputCode formikProps={formikProps} autoFocus={autoFocus} />
      <InputGroupCodeResendCode
        formikProps={formikProps}
        resendCodeActionCreator={resendCodeActionCreator}
        onResendCodeSuccess={onResendCodeSuccess}
        channelCode={channelCode}
      /> */}
  </InputGroup>
);

export default InputGroupCode;
